import { render, staticRenderFns } from "./CmgRewardsExclusivePill.vue?vue&type=template&id=6dc8a263&scoped=true&lang=pug"
import script from "./cmg-rewards-exclusive-pill.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-exclusive-pill.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExclusivePill.vue?vue&type=style&index=0&id=6dc8a263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8a263",
  null
  
)

export default component.exports